<template>
  <el-row style="width: 100%;height: 100%">
    <el-col :span="12">
      <FrameQuery ref="frameQuery" component-param="sys_msg_receive" @current-change="rowChange"></FrameQuery>
    </el-col>

    <el-col :span="12" style="border: solid 1px #e5e5e5">
      <div class="detail-show" v-if="msg.title||msg.content">
        <el-form label-width="110px">

          <el-form-item>
            <el-button @click="replyDialog=true" disabled>回复</el-button>
            <el-button @click="" disabled>回复全部</el-button>
            <el-button @click="forwardDialog=true">转发</el-button>
            <el-button @click="deleteDialog=true">删除</el-button>
          </el-form-item>
          <!--          回复按钮弹窗-->
          <el-dialog title="回复" v-model="replyDialog" :close-on-click-modal="false">
            <el-form v-model="msg" label-width="180px">
              <el-form-item label="标题：" required>
                <el-input v-model="busData.magId" type="input" placeholder="标题"></el-input>
              </el-form-item>
              <el-form-item label="手动确认已读：">
                <el-switch></el-switch>
              </el-form-item>
              <el-form-item label="内容：">
                <KfCkEditor required></KfCkEditor>
              </el-form-item>
              <el-form-item label="附件：">
                <el-upload>
                  <el-icon class="el-icon--upload">
                    <upload-filled/>
                  </el-icon>
                  <div class="el-upload__text">
                    Drop file here or <em>click to upload</em>
                  </div>
                </el-upload>
              </el-form-item>
            </el-form>
            <template #footer>
              <el-button @click="handleClose">取消</el-button>
              <el-button type="primary" @click="setForward">确定</el-button>
            </template>
          </el-dialog>
          <!--          转发按钮弹框-->
          <el-dialog title="转发" v-model="forwardDialog" :close-on-click-modal="false" width="500px">
            <el-form v-model="msg" label-width="80px">
              <el-form-item label="收件人：" required>
                <el-cascader v-model="msg.target_id" :options="departmentAndUserList" style="width: 100%"
                             :show-all-levels="false" placeholder="请选择" :props="props" clearable filterable>
                </el-cascader>
              </el-form-item>
              <el-form-item label="抄送：">
                <el-cascader v-model="msg.copy_id" :options="departmentAndUserList" style="width: 100%"
                             :show-all-levels="false" placeholder="请选择" :props="props" clearable filterable>
                </el-cascader>
              </el-form-item>
            </el-form>
            <template #footer>
              <el-button @click="handleClose">取消</el-button>
              <el-button type="primary" @click="setForward">确定</el-button>
            </template>
          </el-dialog>
          <!--          删除按钮弹框-->
          <el-dialog title="删除" v-model="deleteDialog" :close-on-click-modal="false" width="500px">
            <span style="font-size:20px">确定要删除{{ msg.title }}</span>
            <template #footer class="dialog-footer">
              <el-button @click="deleteDialog=false">取消</el-button>
              <el-button type="primary" @click="deleteMsgRead(msg.id)">确定</el-button>
            </template>
          </el-dialog>
          <el-form-item label="发件人">
            <el-input type="input" :readonly="true" v-model="msg.send_user_name"></el-input>
          </el-form-item>
          <el-form-item label="发送时间">
            <el-input type="input" :readonly="true" v-model="msg.create_time"></el-input>
          </el-form-item>

          <el-form-item label="已读收件人" v-if="msg.read_user_names.length > 0">
            <el-input type="input" :readonly="true" v-model="msg.read_user_names"></el-input>
          </el-form-item>
          <el-form-item label="未读收件人" v-if="msg.unread_user_names.length > 0">
            <el-input type="input" :readonly="true" v-model="msg.unread_user_names"></el-input>
          </el-form-item>
          <el-form-item label="抄送" v-if="msg.copy_user_names.length > 0">
            <el-input type="input" :readonly="true" v-model="msg.copy_user_names"></el-input>
          </el-form-item>
          <el-form-item label="标题">
            <el-input type="input" :readonly="true" v-model="msg.title"></el-input>
          </el-form-item>
          <el-form-item label="内容">
            <KfCkEditor type="textarea" :readonly="true" :rows="15" v-model="msg.content"></KfCkEditor>
          </el-form-item>
          <el-form-item label="附件" v-if="msg.appendix_objects && msg.appendix_objects.length > 0">
            <div class="doc-list">
              <div v-for="appendix in msg.appendix_objects" :key="appendix.id">
                <a :href="appendix.url">{{ appendix.original_name }}</a>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="" v-if="msg.click_read == true">
            <el-button @click="setRead(msg.id)" :disabled="msg.currentRead">我已阅读完毕</el-button>
          </el-form-item>
          <el-form-item label="">
            <el-button v-if="msg.msg_type == 'sys_msg_type_prc'" @click="openPrc(msg)">流程跳转</el-button>
            <el-button v-if="msg.chance_id" @click="openChance(msg)">机会跳转</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-col>
  </el-row>
</template>

<script>

export default {
  name: "MsgReceive",
  data() {
    return {
      props: {
        expandTrigger: 'hover',
        value: 'id',
        label: 'name',
        checkStrictly: false,
        multiple: true,
        emitPath: false
      },
      msg: {
        target_id: "",
        copy_id: "",
      },
      busData: {
        msgId: "",
      },
      forwardDialog: false,
      deleteDialog: false,
      replyDialog: false,
      departmentAndUserList: [],

    }
  },
  methods: {
    reset() {
      this.clearPreData()
      this.$refs.commitMessage.clear()

    },
    clearPreData() {
      this.msg = []
      this.departmentAndUserList = []
    },
    async rowChange(currentRow) {
      let msgId = currentRow?.msg_id
      if (!msgId) {
        return;
      }
      let params = {id: msgId}
      let data = await this.$http('msgService.getMsgDetail', params)
      this.msg = data || {}
      this.getDepartmentAndUser()
    },
    //收件
    async setRead(id) {
      if (!id) {
        return;
      }
      let params = {id: id}
      await this.$http('msgService.setMsgRead', params)
    },
    //获取收件人
    async getDepartmentAndUser() {
      this.departmentAndUserList = await this.$http('sysUserDepartmentService.getDepartmentAndUser')
    },

    //转发消息
    async setForward() {
      await this.$http('msgService.create', this.msg)
      this.$message.success("转发成功")
      this.handleClose()
      this.$refs.frameQuery.search();
      this.clearPreData()
    },
    handleClose() {
      this.forwardDialog = false;
      this.msg.target_id = ''
      this.msg.copy_id = ''
    },
    //删消息
    async deleteMsgRead(id) {
      if (!id) {
        return;
      }
      let params = {id: id}
      await this.$http('msgService.deleteMsgRead', params)
      this.$message.success("删除成功")
      this.$refs.frameQuery.search();
      this.clearPreData()
    },

    downloadFile(appendix) {
      let url = appendix?.active_ver?.sys_file?.url;
      if (!url) {
        return
      }
      let name = appendix.name

      const a = document.createElement('a')

      if (!url.startsWith('http')) {
        url = window.location.protocol + "//" + window.location.host + (url.startsWith('/') ? '' : '/') + url;
      }
      // 这里是将url转成blob地址，
      fetch(url).then(res => res.blob()).then(blob => { // 将链接地址字符内容转变成blob地址
        a.href = URL.createObjectURL(blob)
        a.download = name || '' // 下载文件的名字
        document.body.appendChild(a)
        a.click()

        //在资源下载完成后 清除 占用的缓存资源
        window.URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
      })
    },
    viewFile() {
      this.$store.dispatch('core/openWindow', {
        component: 'oa/ViewPdf',
        name: '文件查看',
        max: true
      })
    },
    getSendUserName(msg) {
      return msg["name@send_user_id"]
    },
    openPrc(data) {
      let windowObj = {}
      windowObj.icon = "system/view";
      windowObj.component = "oa/PrcHandle";
      windowObj.name = "流程查看";
      windowObj.parentData = {id: data.prc_id};
      windowObj.height = 600 || this.$store.getters['core/getGlobalWindowHeight']
      windowObj.width = 1100 || this.$store.getters['core/getGlobalWindowWidth']
      windowObj.no_min = true
      windowObj.max = true

      this.$store.dispatch('core/openWindow', windowObj)
    },
    openChance(msg) {
      let windowObj = {}
      windowObj.icon = "system/view";
      windowObj.component = "frame/FrameTab";
      windowObj.componentParam = "sales_chance_tab";
      windowObj.name = msg.chance_company_name;
      windowObj.parentData = {id: msg.chance_id};
      windowObj.height = 800
      windowObj.width = 1200
      windowObj.max = true
      windowObj.$params = {
        activeTabName: "跟进记录",
      }

      this.$store.dispatch('core/openWindow', windowObj)
    },
  }
}
</script>

<style lang="less" scoped>
.detail-show {
  padding: 15px 30px 5px 5px;
  min-height: 600px;
  word-break: break-all;
}

.doc-list {
  width: 100%;
  min-height: 100px;
}

</style>